import {
    ContentLoader, FlexGap,
    FullWidthSidebar,
    ItemRowHeader,
    StackHorizontal,
    StackVertical,
    useLayout,
    useTranslation
} from '@twigsby/frontend-framework';
import React, {useEffect, useRef, useState} from "react";
import {EndpointError} from "../../Components/EndpointError";
import MailboxNavigation from "../../Components/Mail/MailboxNavigation";
import {SelectedMailToolbarContent} from "../../Components/Mail/Menus/SelectedMailToolbarContent";
import {MailItemHeader} from "../../Components/MailItem/Components/MailItemHeader";
import {MailItemContent} from "../../Components/MailItem/MailItemContent";
import {SentMailItemContent} from "../../Components/MailItem/SentItemContent";
import {useMailbox} from "../../Providers/NewMailboxProvider";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const MailItemPage = (props: any) => {
    const { t } = useTranslation();
    const { isMedium, isLarge } = useLayout();
    const { updatePageMeta, currentLocale } = useSite();

    const { MarkMailItemAsRead, mailItemData, mailItemStatus, mailItemError, FilterActions, mailBoxInfo, MoveItemsToFolder, mailItemOnHold, mailItemRequiresTopUp } = useMailbox();

    const [mailboxTopBarHeight, setMailboxTopBarHeight] = useState<number>(0)

    const mailToolbarRef = useRef<HTMLDivElement | null>(null);
    const mailBoxNavigationRef = useRef<any>();

    useEffect(() => {
        if(mailItemData && !mailItemData.dateRead) {
            MarkMailItemAsRead()
        }

        if(mailItemData && mailItemData.actions?.length > 0) {
            FilterActions([{ mailUuid: mailItemData.mailUuid, actions: mailItemData.actions }], [mailItemData.mailUuid]);
        }
    }, [mailItemData]);

    useEffect(() => {
        updatePageMeta({
            title: mailItemStatus === 'success' ? `${mailItemData?.trackingId} - ${t('mailItem.title')}` : t('mailItem.title')
        });
    }, [currentLocale, mailItemStatus, mailItemData]);

    useEffect(() => {
        if(mailToolbarRef.current) {
            setMailboxTopBarHeight(mailToolbarRef.current?.clientHeight);
        }
    }, [mailToolbarRef.current]);

    return (
        <FullWidthSidebar
            navigationComponent={
                <>
                    {isLarge && (
                        <MailboxNavigation
                            ref={mailBoxNavigationRef}
                            title={mailBoxInfo.folderName}
                            createFolderSuccessCallback={(e: any) => MoveItemsToFolder(e)}
                        />
                    )}
                </>
            }
            extraContentClass={`flex-column mail-item-container ${mailItemStatus === 'loading' ? 'disabled' : ''}`}
        >
            {mailItemStatus === "loading" ? (
                <>
                    <div className={'page-header'}>
                        <div className={'container-narrow'}>
                            <div className={'row'}>
                                <div className={'col-xs-12 col-md-4 col-lg-3'}>
                                    <ContentLoader rounded={true} childCount={1} childHeight={'3.85em'} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <ItemRowHeader extraClass={'mail-item-toolbar p-md'}>
                        <div className={'container-narrow'}>
                            <div className={'item-row-toolbar'}>
                                <StackHorizontal gap={FlexGap.ExtraSmall}>
                                    <ContentLoader rounded={true} childCount={1} childHeight={'2.5em'} childWidth={'10em'}/>
                                    <ContentLoader rounded={true} childCount={1} childHeight={'2.5em'} childWidth={'10em'}/>
                                    <ContentLoader rounded={true} childCount={1} childHeight={'2.5em'} childWidth={'10em'}/>
                                </StackHorizontal>
                            </div>
                        </div>
                    </ItemRowHeader>

                    <div className={'column-adjuster pl-md pr-md'}>
                        <div className={'container-narrow'}>
                            <div className={'row'}>
                                <div className={'col-xs-12 col-lg-4 col-xl-3'}>
                                    <div className={'mail-item-meta-grid'}>
                                        <ContentLoader rounded={true} childCount={1} childHeight={'4em'}/>
                                        <ContentLoader rounded={true} childCount={1} childHeight={'4em'}/>
                                        <ContentLoader rounded={true} childCount={1} childHeight={'4em'}/>
                                    </div>
                                </div>
                                <div className={'col-xs-12 col-lg-8 col-xl-9'}>
                                    <div className={'mail-item-contents'}>
                                        <StackVertical>
                                            <StackHorizontal extraClass={'mb-sm'}>
                                                <h6 className={`pageantry-sub-heading text-left m-0`}>{t('status.loading')}</h6>
                                            </StackHorizontal>
                                            <ContentLoader rounded={true} childCount={1} childHeight={'40em'}/>
                                        </StackVertical>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : mailItemStatus === "error" && mailItemError  ? (
                <div className={'fill-container p-md'}>
                    <EndpointError {...mailItemError} stacked={true} />
                </div>
            ) : (
                <>
                    <div className={`mail-item-page-header sticky`} ref={mailToolbarRef}>
                        <div className={`page-header ${mailItemData?.holdReason || (mailItemData?.files && mailItemData?.files.length > 0 && mailItemData?.files[0].topupRequired) ? 'account-issue-highlight from-left show-issues' : ''}`}>
                            <div className={'container-narrow'}>
                                <MailItemHeader />
                            </div>
                        </div>

                        {isMedium && !mailItemOnHold && !mailItemRequiresTopUp && (
                            <ItemRowHeader extraClass={'mail-item-toolbar p-md'}>
                                <div className={'container-narrow'}>
                                    <div className={'item-row-toolbar'}>
                                        <SelectedMailToolbarContent
                                            showCustomFolderRemove={!!mailBoxInfo.customFolderId && mailBoxInfo.customFolderId > -1}
                                        />
                                    </div>
                                </div>
                            </ItemRowHeader>
                        )}
                    </div>

                    <div className={'column-adjuster pl-md pr-md'}>
                        <div className={'container-narrow'}>
                            {mailItemData?.mailLocationId !== 7 && (
                                <MailItemContent mailboxTopBarHeight={mailboxTopBarHeight} />
                            )}

                            {mailItemData?.mailLocationId === 7 && (
                                <SentMailItemContent mailboxTopBarHeight={mailboxTopBarHeight} />
                            )}
                        </div>
                    </div>
                </>
            )}
        </FullWidthSidebar>
    )
}

export default MailItemPage
